import React from 'react';
import { useOfferContext } from '../../../context';
import { SimilarLink } from '../../../components/SimilarLink';
import { trackSuburbanMultiOfferClick } from './tracking';

export function SimilarLinkContainer() {
  const { similarLink, offer, tracking, position } = useOfferContext();

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>): void => {
      e.stopPropagation();

      const { kp, gaLabel } = offer;

      if (gaLabel) {
        if (kp) {
          trackSuburbanMultiOfferClick(kp.id, gaLabel, position);
        } else {
          tracking.trackMultiOfferClick(gaLabel);
        }
      }
    },
    [offer, tracking, position],
  );

  if (!similarLink) {
    return null;
  }

  return <SimilarLink {...similarLink} onClick={handleClick} />;
}
